export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/a70fe28c30edbe909cade8425716fdee.svg";